import { useStore } from 'vuex'
import { onMounted, computed, ref, defineEmits } from 'vue'
import { useTabTrap } from 'foundation/js/useTabTrap'
import formatNewlines from 'foundation/js/formatNewlines'

export default {
    name: 'MemberListOverlayFrivillig',
    emits: ['setTabTargets'],
    props: {},
    setup({ emit }) {
        const store = useStore()
        const overlayRef = ref(null)

        const groupId = computed(() => store.state.main.page_overlay_content_data.groupId)
        const isSubmitting = computed(() => store.state.frivillige.is_submitting)
        const members = computed(() => store.state.frivillige.member_list_data)

        const skip = ref(0)
        const take = ref(10)

        const canMessage = ref(false)
        const canRemove = ref(false)

        const memberCount = computed(
            () => store.state.frivillige.member_list_data_total
        )
        const hasMore = computed(
            () => members.value?.length < memberCount.value
        )

        const { setTabTargets, tabTrap } = useTabTrap(overlayRef, emit)

        const fetchGruppemedlemmer = function () {
            store.dispatch('frivillige/fetchGruppemedlemmerData', {
                pageId: store.state.main.page_id,
                groupId: groupId.value,
                skip: skip.value,
                take: take.value
            })
            .then((result) => {
                canRemove.value = result.canRemoveMembers
                canMessage.value = result.canMessage
                setTabTargets()
            })
        }

        const loadMore = function () {
            skip.value = take.value + skip.value
            fetchGruppemedlemmer()
        }

        onMounted(() => {
            fetchGruppemedlemmer()
        })

        const toggleAccordion = function (e) {
            const isExpanded = !!(
                e.currentTarget.getAttribute('aria-expanded') === 'true'
            )
            const accordionTarget = document.querySelector(
                `#${e.currentTarget.getAttribute('aria-controls')}`
            )
            const chevronTarget = e.currentTarget.querySelector(
                '.kb-member-list-overlay__member-chevron'
            )

            chevronTarget.classList[isExpanded ? 'remove' : 'add'](
                'kb-member-list-overlay__member-chevron--open'
            )
            accordionTarget.classList[isExpanded ? 'remove' : 'add'](
                'kb-member-list-overlay__content--open'
            )
            e.currentTarget.setAttribute(
                'aria-expanded',
                isExpanded ? 'false' : 'true'
            )

            accordionTarget.querySelectorAll('a').forEach((a) => {
                if (isExpanded) {
                    a.setAttribute('tabindex', -1)
                } else {
                    a.removeAttribute('tabindex')
                }
            })
        }

        const getLabel = (labelKey, strings) => {
            let label = store.getters['labels/getLabel']({
                labelCollection: 'MemberListOverlayFrivillig',
                labelKey
            })

            if (strings) {
                strings.forEach((str, index) => {
                    label = label.replace(`{${index}}`, str)
                })
            }

            return label
        }

        const handleRemoveMember = async (frivilligprofilId) => {
            const config = {
                groupId: groupId.value,
                frivilligprofilId: frivilligprofilId
            }
            await store.dispatch('frivillige/removeMember', config)
            store.dispatch('main/closePageOverlay')
        }

        const getRolleText = (roller) => {
            return roller
                .map((r) => {
                    return r.gruppeName == undefined
                        ? `${r.rolleName}`
                        : `${r.rolleName} - ${r.gruppeName}`
                })
                .join(', ')
        }

        return {
            members,
            memberCount,
            isSubmitting,
            canRemove,
            canMessage,
            hasMore,
            overlayRef,
            toggleAccordion,
            tabTrap,
            handleRemoveMember,
            getLabel,
            fetchGruppemedlemmer,
            loadMore,
            getRolleText,
            formatNewlines
        }
    }
}